import { api } from '../services/api.js';
import { gameState } from '../state/gameState.js';
import type { PlayerSnapshot } from '../state/gameState.js';

function fmt(centStr: string): string {
  return (parseFloat(centStr) / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function setEl(id: string, text: string): void {
  const el = document.getElementById(id);
  if (el !== null) el.textContent = text;
}

export async function refreshBalance(): Promise<void> {
  try {
    const fresh = await api.get<PlayerSnapshot>('/auth/me');
    gameState.setPlayer(fresh);
    setEl('header-nox-balance', `${fmt(fresh.noxBalance)} ₦`);
    setEl('header-black-money', `${fmt(fresh.blackMoney)} S-₦`);
    setEl('sidebar-balance', `${fmt(fresh.noxBalance)} ₦`);
    setEl('sidebar-black-money', `${fmt(fresh.blackMoney)} S-₦`);
    setEl('header-scheine', String(fresh.scheine ?? 0));
  } catch {
    // Balance-Update ist nicht kritisch
  }
}
